import { useLocale as useLocaleR42 } from '@/lib/locale';
import React from 'react';

/**
 * SplashPad logo: light-blue "S" with two swimmers + water splash.
 * The PNG asset lives at /splashpad-logo.png (transparent background).
 *
 * Sizes:
 *   sm  -> 28px mark, base text
 *   md  -> 36px mark, xl text  (default)
 *   lg  -> 48px mark, 2xl text
 */
export function Logo({ size = 'md', light = false, showWordmark = true, testId = 'sp-logo' }) {
    const { t: t42 } = useLocaleR42();
    const markPx = size === 'lg' ? 48 : size === 'sm' ? 28 : 36;
    const titleClass =
        size === 'lg' ? 'text-2xl' : size === 'sm' ? 'text-base' : 'text-xl';

    return (
        <div className="flex items-center gap-2.5 font-display" data-testid={testId}>
            <img
                src="/splashpad-logo.png"
                alt="SplashPad"
                width={markPx}
                height={markPx}
                style={{ width: markPx, height: markPx, objectFit: 'contain' }}
                draggable={false}
            />
            {showWordmark && (
                <div className={`leading-tight ${titleClass}`}>
                    <div className={`font-bold tracking-tight ${light ? 'text-white' : 'text-[#0a1628]'}`}> {t42("SplashPad")} </div>
                    <div className={`text-[10px] tracking-widest uppercase ${light ? 'text-white/70' : 'text-[#1a3a5c]/70'}`}> {t42("by SSU")} </div>
                </div>
            )}
        </div>
    );
}
